export { default as DetailsHeader } from "./DetailsHeader";
export * from "./StatusSection";
export * from "./PreventionLevelsSection";
export * from "./ProjectSummarySection";
export * from "./BeneficiariesSection";
export * from "./FinancialSection";
